import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-xl-6 mb-3" }
const _hoisted_8 = { class: "col-xl-6 mb-3" }
const _hoisted_9 = {
  class: "form-floating btn-group col-12",
  id: "com-type-control"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center text-secondary text-truncate" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "country-name ms-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "dropdown-menu scrollable-menu dropdown-menu-end" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "text-center ps-0" }
const _hoisted_21 = { class: "fw-lighter ps-2" }
const _hoisted_22 = { class: "col-xl-6 mb-3" }
const _hoisted_23 = {
  class: "input-group",
  id: "com-amount-control"
}
const _hoisted_24 = { class: "form-control border-0 p-0" }
const _hoisted_25 = { class: "form-floating" }
const _hoisted_26 = ["disabled", "readonly"]
const _hoisted_27 = { class: "col-xl-6 mb-3" }
const _hoisted_28 = {
  class: "form-floating btn-group col-12",
  id: "com-status-control"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "country-name ms-2" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "dropdown-menu scrollable-menu dropdown-menu-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["id"]
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = { class: "text-center ps-0" }
const _hoisted_39 = { class: "fw-lighter ps-2" }
const _hoisted_40 = { class: "col-12 mb-3" }
const _hoisted_41 = {
  class: "form-floating",
  id: "com-origin-control"
}
const _hoisted_42 = ["disabled", "readonly"]
const _hoisted_43 = { class: "row mt-2" }
const _hoisted_44 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-money-check-alt fa-fw me-1" }),
        _createTextVNode("Agregar Comisión ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input secondary",
            type: "checkbox",
            role: "switch",
            id: "share-email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.update) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.update]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_VueDatePicker, {
            "model-value": _ctx.commissionRecord.date,
            "onUpdate:modelValue": _ctx.setCommissionDate,
            disabled: !_ctx.update || _ctx.adding,
            name: "commissionDate",
            vertical: "",
            "action-row": { showNow: true, showPreview: true },
            "select-text": "Aceptar",
            "cancel-text": "Cancelar",
            "now-button-label": "Ahora",
            "enable-time-picker": true,
            "is-24": true,
            "time-picker-inline": "",
            class: _normalizeClass(["form-control form-floating", _ctx.readOnlyClassesObject]),
            "input-class-name": 
              _ctx.readOnlyClassesString + ' text-secondary my-1 pe-0'
            ,
            format: _ctx.formatDate
          }, null, 8, ["model-value", "onUpdate:modelValue", "disabled", "class", "input-class-name", "format"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control flex-fill d-flex rounded-0 rounded-start text-center", _ctx.readOnlyClassesObject]),
              disabled: !_ctx.update || _ctx.adding,
              type: "text",
              id: "commission-type-input",
              style: {"color":"transparent !important"},
              placeholder: "Tipo",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.commissionRecord.type.label) = $event))
            }, null, 10, _hoisted_10), [
              [_vModelText, _ctx.commissionRecord.type.label]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.commissionRecord.type.icon)
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.commissionRecord.type.label), 1)
              ])
            ]),
            _createElementVNode("button", {
              class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
              id: "commission-type-button",
              disabled: !_ctx.update || _ctx.adding
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Tipos de Comisión", -1)
            ]))], 8, _hoisted_15),
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTypesConfig, (t) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: t.code,
                  onClick: ($event: any) => (_ctx.commissionRecord.type = t)
                }, [
                  _createElementVNode("button", {
                    class: "dropdown-item ps-2",
                    id: 'item-type-' + t.code
                  }, [
                    _createElementVNode("span", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createElementVNode("i", {
                          class: _normalizeClass(t.icon)
                        }, null, 2)
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(t.label), 1)
                    ])
                  ], 8, _hoisted_18)
                ], 8, _hoisted_17))
              }), 128))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "commission-type-input",
              class: "opacity-100"
            }, "Tipo", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "G$", -1)),
            _createElementVNode("span", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control fw-bold text-center rounded-0", {
                    ..._ctx.readOnlyClassesObject,
                    'is-invalid': _ctx.amountWarning,
                  }]),
                  id: "commission-source",
                  placeholder: "Origen",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.commissionRecord.amount) = $event)),
                  disabled: !_ctx.update || _ctx.adding,
                  readonly: !_ctx.update
                }, null, 10, _hoisted_26), [
                  [
                    _vModelText,
                    _ctx.commissionRecord.amount,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "commission-source",
                  class: "opacity-100 moz-mt-3"
                }, [
                  _createElementVNode("span", null, "Monto")
                ], -1))
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text" }, "USD", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control flex-fill d-flex rounded-0 rounded-start text-center", _ctx.readOnlyClassesObject]),
              type: "text",
              id: "commission-status-input",
              style: {"color":"transparent !important"},
              placeholder: "Estado",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.commissionRecord.status.label) = $event)),
              disabled: !_ctx.update || _ctx.adding
            }, null, 10, _hoisted_29), [
              [_vModelText, _ctx.commissionRecord.status.label]
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", {
                class: _normalizeClass(
                  'd-flex flex-row align-items-center text-secondary text-truncate ' +
                  _ctx.commissionRecord.status.colorClass
                )
              }, [
                _createElementVNode("span", _hoisted_31, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.commissionRecord.status.icon)
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.commissionRecord.status.label), 1)
              ], 2)
            ]),
            _createElementVNode("button", {
              class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
              id: "commission-status-button",
              disabled: !_ctx.update || _ctx.adding
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Estados de la Comisión", -1)
            ]))], 8, _hoisted_33),
            _createElementVNode("ul", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStatusesConfig, (s) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: s.code,
                  onClick: ($event: any) => (_ctx.commissionRecord.status = s)
                }, [
                  _createElementVNode("button", {
                    class: "dropdown-item ps-2",
                    id: 'item-status-' + s.code
                  }, [
                    _createElementVNode("span", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, [
                        _createElementVNode("i", {
                          class: _normalizeClass(s.icon + ' ' + s.colorClass)
                        }, null, 2)
                      ]),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(s.label), 1)
                    ])
                  ], 8, _hoisted_36)
                ], 8, _hoisted_35))
              }), 128))
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              for: "commission-type-input",
              class: "opacity-100"
            }, "Estatus", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control fw-bold text-center", _ctx.readOnlyClassesObject]),
              id: "commission-source",
              placeholder: "Origen",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.commissionRecord.source) = $event)),
              disabled: !_ctx.update || _ctx.adding,
              readonly: !_ctx.update || _ctx.adding
            }, null, 10, _hoisted_42), [
              [
                _vModelText,
                _ctx.commissionRecord.source,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              for: "commission-source",
              class: "opacity-100"
            }, [
              _createElementVNode("span", { class: "" }, "Concepto")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            disabled: !_ctx.update || _ctx.adding,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCommission()))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
            _cache[16] || (_cache[16] = _createTextVNode("Agregar ", -1)),
            (_ctx.adding)
              ? (_openBlock(), _createElementBlock("i", _hoisted_46))
              : _createCommentVNode("", true)
          ], 8, _hoisted_45)
        ])
      ])
    ])
  ]))
}